import axios from 'axios';

export default {
    async fetchDocuments(props) {
        let url = '/documents';
        if (props) {
            let i = 0;
            for (const [key, value] of Object.entries(props)) {
                if (value) {
                    if (i !== 0) {
                        url += '&';
                    } else {
                        url += '?';
                    }
                    url += key + '=' + value;
                    i++;
                }
            }
        }
        return axios.get(url);
    },

    async fetchDocument(id) {
        return axios.get('/documents/' + id);
    },

    async fetchDocumentFiles(id) {
        return axios.get(`/documents/${id}/files`);
    },

    async fetchDocumentDefinitions() {
        return axios.get('/documents/definitions');
    },

    async updateDocument(document) {
        return axios.put('/documents',
            document,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async createDocument(document) {
        return axios.post('/documents',
            document,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async deleteDocument(documentId) {
        return axios.delete('/documents/' + documentId);
    },

    async uploadFiles(documentId, files) {
        const formData = new FormData();
        files.forEach(file => formData.append('files', file, file.name.split('.')[0]));
        formData.append('documentId', documentId);
        return axios.post('/documents/upload-files',
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
    },

    async archiveDocumentFiles(files) {
        return axios.post('/documents/files/archive',
            files.map(file => file.id),
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
    }
}
